// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type TeamBillableInfoResponse = SlackAPIResponse & {
  billable_info?: { [key: string]: BillableInfo };
  error?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
  response_metadata?: ResponseMetadata;
};

export interface BillableInfo {
  billing_active?: boolean;
}

export interface ResponseMetadata {
  next_cursor?: string;
}
